import { canv } from '@/canv/global.js'

export class shapeLSkewRect {

    constructor() {

    }

    drawLSkewRoundedRect(x, y, w, h, r, skew) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+w - skew, y,   x+w , y+h, r);
        canv.ctx.arcTo(x+w, y+h, x + skew,   y+h, r);
        canv.ctx.arcTo(x + skew,   y+h, x,   y,   r);
        canv.ctx.arcTo(x ,   y,   x+w - skew, y,   r);
        canv.ctx.closePath();
    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {


        var allowedWidth = width / 3 - 2 * horizontalPadding;
        var allowedHeight = height - 2 *  verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        this.drawLSkewRoundedRect(x, y, width, height, 4, width / 3);
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M60 0H0L20 80H80L60 0Z" fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.3596 24.5L18.3596 0.5H0.640388L6.64039 24.5H24.3596Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
